import { BaseMapper } from '../shared/base.mapper';
import { Country } from '../../types/country/country.type';
import { Injectable } from "@angular/core";

@Injectable()
export class CountryMapper extends BaseMapper<Country> {

}
